import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify"
import "./plugins/chartist";
import VueTheMask from "vue-the-mask";
import VueChartist from "vue-chartist";
import vueHeadful from "vue-headful";
import Toolbar from "./components/core/Toolbar.vue";
import NavigationDrawer from "./components/core/NavigationDrawer.vue";
import Card from "./components/material/Card.vue";
import ChartCard from "./components/material/ChartCard.vue";
import HelperOffset from "./components/helper/Offset.vue";
import Vue2Filters from "vue2-filters";
import CgiCadastroInfoItem from "@/components/cgi/dados-cadastrais/CgiCadastroInfoItem";
import CgiCardImagemPerfil from "@/components/cgi/dados-cadastrais/CgiCardImagemPerfil";
import CgiCardDependente from "@/components/cgi/dependentes/CgiCardDependente";
import CgiAlerta from "@/components/cgi/CgiAlerta";
import TituloResponsivo from "@/components/helper/TituloResponsivo";
import FormDependenteResponsivo from "@/components/forms/FormDependenteResponsivo";
import FormDadosCadastrais from "@/components/forms/FormDadosCadastrais";
import CgiDataPicker from "@/components/cgi/cgi-data-picker";
import moment from "moment";
import CountryFlag from 'vue-country-flag'
import cids from 'cids-cgi/lib'

import { locale } from './locale/locale'

Vue.use(VueTheMask);
Vue.use(VueChartist);
Vue.use(Vue2Filters);
Vue.use(cids);

Vue.component('country-flag', CountryFlag)
Vue.component("vue-headful", vueHeadful);
Vue.component("material-card", Card);
Vue.component("material-chart-card", ChartCard);
Vue.component("helper-offset", HelperOffset);
Vue.component("core-toolbar", Toolbar);
Vue.component("navigation-drawer", NavigationDrawer);
Vue.component("cgi-cadastro-info-item", CgiCadastroInfoItem);
Vue.component("cgi-card-imagem-perfil", CgiCardImagemPerfil);
Vue.component("cgi-card-dependente", CgiCardDependente);
Vue.component("cgi-alerta", CgiAlerta);
Vue.component("titulo-responsivo", TituloResponsivo);
Vue.component("form-dependente-responsivo", FormDependenteResponsivo);
Vue.component("form-dados-cadastrais", FormDadosCadastrais);
Vue.component("cgi-data-picker", CgiDataPicker);

Vue.prototype.moment = moment;
Vue.prototype.locale = locale


const local = localStorage.getItem('local', local)

Vue.prototype.local = local ?? 'pt-BR'
window['local'] = local ?? 'pt-BR'


Vue.config.productionTip = false;
Vue.prototype.$clienteNome = process.env.VUE_APP_CLIENTE;
Vue.prototype.$clienteNomeFantasia = process.env.VUE_APP_CLIENTE_FANTASIA;
Vue.prototype.$corPrimaria = process.env.VUE_APP_COR_PRIMARIA;
Vue.prototype.$metodoRecuperacaoSenha = 1; // 1 - SMS, 2 - EMAIL
Vue.prototype.$recuperacaoSenhaEmail = "TRUE"
  //process.env.VUE_APP_RECUPERACAO_SENHA_SMS == "true";
Vue.prototype.$logId = process.env.VUE_APP_LOG_ID;
Vue.prototype.$alteracaoNomeObrigaEstadoCivil =
  process.env.VUE_APP_ALTERACAO_NOME_OBRIGA_ESTADO_CIVIL == "TRUE"
    ? true
    : false;
Vue.prototype.$senhaApenasNumerica =
  process.env.VUE_APP_SENHA_APENAS_NUMERICA == "TRUE" ? true : false;

Vue.prototype.$dadosCadastrais = process.env.VUE_APP_DADOS_CONTRATUAIS_TAB === 'true'

// Vue.prototype.$showCard = process.env.VUE_APP_COD_CLI
//   ? process.env.VUE_APP_COD_CLI == 5526 || process.env.VUE_APP_COD_CLI == 59
//     ? true
//     : false
//   : false;

window.addEventListener("beforeunload", function (e) {      
  if (sessionStorage.getItem("lembrarme") !== "true") {
    const local = localStorage.getItem('local', local) ?? 'pt-BR'
    localStorage.clear()
    localStorage.setItem('local', local)
  }
})


/* eslint-disable no-new */
new Vue({
  router,
  store,
  vuetify,
  // chartist,
  render: h => h(App)
}).$mount("#app");
